
<a-select
  :options="displayRuleOptions"
  v-model.sync="localValue"
  :is-searchable="false"
  has-teleport>
</a-select>
